import React from 'react';
import FoldedCardProductImage from './folded-card-product-image';
import MetallicCardProductImage from './metallic-card-product-image';
import ProductImage from './product-image';
import ProductVideo from './product-video';

const PreviewImage = ({ asset, index, isMobile, ...props }) => {
  const attributes = {
    isRounded: props.rounded_corners,
    isElegant: props.elegant_corners,
    isScalloped: props.scalloped_edges,
    isCard: props.product.is_card,
  };
  const {
    selectedTheme,
    product: { title: productTitle },
  } = props;
  const alt = selectedTheme
    ? `${productTitle} with ${selectedTheme.title} design`
    : productTitle;

  const isProductFoldedCard = () => {
    return isProductMatch([/Folded Card/i, /Note Card/i]);
  };
  const isProductMetallicCard = () => {
    return isProductMatch(/Metallic(\W*)Greeting Card/i);
  };
  const isProductMatch = (titleRegexes) => {
    titleRegexes = [].concat(titleRegexes);

    return titleRegexes.some((regex) => {
      return regex.test(props.product.title);
    });
  };
  const customisationOptionAsset = () => {
    const { selectedOptions = {}, productOptions = [] } = props;
    const [{ id, display_overlay_preview: displayOverlayPreview } = {}] =
      productOptions;
    const { [id]: { asset } = {} } = ({} = selectedOptions);

    return index === 0 && displayOverlayPreview ? asset : undefined;
  };
  if (asset.type == 'video') {
    return <ProductVideo url={asset.url} />;
  }
  if (asset.type == 'image') {
    if (isProductFoldedCard())
      return <FoldedCardProductImage url={asset.url} />;

    if (isProductMetallicCard())
      return <MetallicCardProductImage url={asset.url} />;

    return (
      <ProductImage
        key={index}
        index={index}
        isMobile={isMobile}
        url={asset.url}
        alt={`${alt} ${index + 1}`}
        {...attributes}
        optionAsset={customisationOptionAsset()}
      />
    );
  }

  return (
    <div className="flex-video">
      <iframe
        key={index}
        src={asset.url}
        scrolling="no"
        frameBorder="no"
        className="img-fluid mx-auto"
        allowFullScreen
      />
    </div>
  );
};

export default PreviewImage;
